const messages = {
  title: "Bonus",
  word: "Bonus",
  description: "Alle aziende partecipanti vengono accreditate le commissioni kickback in base ai dati di vendita trasmessi.",
};

export default {
  messages,
};
